import { render, staticRenderFns } from "./ReleaseVersionRail.vue?vue&type=template&id=4ef42e9a&scoped=true"
import script from "./ReleaseVersionRail.vue?vue&type=script&lang=js"
export * from "./ReleaseVersionRail.vue?vue&type=script&lang=js"
import style0 from "./ReleaseVersionRail.vue?vue&type=style&index=0&id=4ef42e9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef42e9a",
  null
  
)

export default component.exports